import SideMenu from './SideMenu';

export default SideMenu;



// WEBPACK FOOTER //
// ./src/components/SideMenu/index.jsx